import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import Image from "react-bootstrap/Image";

export const ReportsLiveChart = ({
  iconImage,
  altText,
  titleText,
  imageClass,
  headingText,
  paragraphText,
  now,
  progressBar,
}) => {
  return (
    <React.Fragment>
      <div className="main-progress-bar">
        <div className="main-progress-bar-sectionone">
          <div className="d-flex align-items-center">
            <Image
              src={iconImage}
              alt={altText}
              title={titleText}
              fluid
              className={imageClass}
            />
            <h5>{headingText}</h5>
          </div>
          <p>{paragraphText}</p>
        </div>
        <ProgressBar now={now} className={progressBar} />
      </div>
    </React.Fragment>
  );
};
